export default __webpack_public_path__ + "static/ABA_2020_Winner_Commercial_broker_of_the_year-ea8151aa469398d5061efb6e75e0b677.png";